import { useState } from 'react';
import { Point } from '../../../../shared/types/mathTypes.ts';
import { LinkButton } from '../../../components/linkButton.tsx';
import { CmmConfig } from '../../../types/sharedTypeImpl.ts';
import { CmmConfigContextMenu } from './cmmConfigContextMenu.tsx';

interface ContextMenuState {
    location: Point;
    cmmConfig: CmmConfig;
}


interface Props {
    style: React.CSSProperties;
    cmmConfigs: CmmConfig[];
    onIsActiveChange: (cmmConfig: CmmConfig, isActive: boolean) => void;
    onEditClick: (cmmConfig: CmmConfig) => void;
    onOrderChange: (cmmConfig: CmmConfig, direction: 'up' | 'down') => void;
}

export function CmmConfigsTable({
    style,
    cmmConfigs,
    onEditClick,
    onIsActiveChange,
    onOrderChange
}: Props) {

    const [contextMenu, setContextMenu] = useState<ContextMenuState | null>(null);


    const handleMenuOpen = (event: React.MouseEvent, cmmConfig: CmmConfig) => {
        event.stopPropagation();
        setContextMenu({ location: { x: event.clientX, y: event.clientY }, cmmConfig });
    };

    return <>
        <table style={style}>
            <thead>
                <tr>
                    <th>Is active</th>
                    <th>Name</th>
                    <th>Edit</th>
                    <th />
                </tr>
            </thead>
            <tbody>
                {cmmConfigs?.map(it =>
                    <tr key={it._id}>
                        <td>
                            <input
                                type='checkbox'
                                checked={it.isActive}
                                onChange={(e) => onIsActiveChange(it, e.target.checked)}
                            />
                        </td>
                        <td>{it.name}</td>
                        <td>
                            <LinkButton
                                onClick={() => onEditClick(it)}
                                content='Edit'
                            />
                        </td>
                        <td>
                            <LinkButton
                                onClick={e => handleMenuOpen(e, it)}
                                content='Options'
                            />
                        </td>
                    </tr>
                )}
            </tbody>
        </table>

        {
            contextMenu && <CmmConfigContextMenu
                screenCoords={contextMenu.location}
                cmmConfig={contextMenu.cmmConfig}
                onOrderChange={onOrderChange}
                onClose={() => setContextMenu(null)}
            />
        }
    </>
}
